import { ReactComponent as CardCarIcon } from './images/card_car.svg';
import { ReactComponent as CardBookIcon } from './images/card_book.svg';
import { ReactComponent as CardCoinIcon } from './images/card_coin.svg';
import { ReactComponent as CardDinosaurIcon } from './images/card_dinosaur.svg';
import { ReactComponent as CardEvilIcon } from './images/card_evil.svg';
import { ReactComponent as CardPencilIcon } from './images/card_pencil.svg';
import { ReactComponent as CardKeyboardIcon } from './images/card_keyboard.svg';
import { ReactComponent as CardRocketIcon } from './images/card_rocket.svg';
import { ReactComponent as CardTrueIcon } from './images/card_true.svg';

import { ReactComponent as CardBankIcon } from './images/card_bank.svg';
import { ReactComponent as CardVideoIcon } from './images/card_video.svg';
import { ReactComponent as CardArrowsIcon } from './images/card_arrows.svg';
import { ReactComponent as CardPlanetIcon } from './images/card_planet.svg';
import { ReactComponent as CardHistoryIcon } from './images/card_history.svg';
import { ReactComponent as CardComputerIcon } from './images/card_computer.svg';

// Course card icons
import { ReactComponent as CourseCardComputerIcon } from './components/CourseCard/images/card_сomputer_icon.svg';
import { ReactComponent as CourseCardComputerIcon2 } from './components/CourseCard/images/card_сomputer_icon_2.svg';
import { ReactComponent as CourseCardBookIcon } from './components/CourseCard/images/card_book_icon.svg';
import { ReactComponent as CourseCardBookIcon2 } from './components/CourseCard/images/card_book_icon_2.svg';
import { ReactComponent as CourseCardFriendsIcon } from './components/CourseCard/images/card_friends_icon.svg';
import { ReactComponent as CourseCardFriendsIcon2 } from './components/CourseCard/images/card_friends_icon_2.svg';
import { ReactComponent as CourseCardMoneyIcon } from './components/CourseCard/images/card_money_icon.svg';
import { ReactComponent as CourseCardMoneyIcon2 } from './components/CourseCard/images/card_money_icon_2.svg';
import { ReactComponent as CourseCardSafetyIcon } from './components/CourseCard/images/card_safety_icon.svg';
import { ReactComponent as CourseCardMooveIcon } from './components/CourseCard/images/card_moove_icon.svg';
import { ReactComponent as CourseCardThinkIcon } from './components/CourseCard/images/card_think_icon.svg';
import { ReactComponent as CourseCardThinkIcon2 } from './components/CourseCard/images/card_think_icon_2.svg';

// Subjects card icons
import { ReactComponent as SubjectMathIcon } from './components/SubjectCard/images/subject_math_icon.svg';
import { ReactComponent as SubjectRussianIcon } from './components/SubjectCard/images/subject_russian_icon.svg';
import { ReactComponent as SubjectEnglishIcon } from './components/SubjectCard/images/subject_english_icon.svg';
import { ReactComponent as SubjectEnvironmentIcon } from './components/SubjectCard/images/subject_environment_icon.svg';

// Логирование
export const EVENT_SOURCE = {
  PODPISKA: 'pryamyye_efiry_podpiska',
  COURSES: 'pryamyye_efiry_minikursy',
  SHKOLA: 'pryamyye_efiry_shkola',
};

export const EVENT_TYPE = {
  VISIT_LAND: 'visit_land',
  CLICK_BUY: 'click_buy',
  CLICK_CHOOSE: 'click_choose',
  COURSE_INFO: 'course_info',
  SEEN_CAPCHA: 'seen_capcha',
  CLICK_BACK_CAPCHA: 'click_back_capcha',
  CAPCHA_WRONG: 'capcha_wrong',
  SORRY: 'sorry_page',
};

export enum PriceType {
  DEFAULT,
  COURSES,
  SUBJECTS,
}

export type Price = {
  price: number;
  basePrice: number;
  discount: string;
  priceForLesson: number;
};

export type SubjecCardType = {
  id: number;
  title: string;
  date: string;
  list: string[];
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
};

export type CourseCardType = {
  id: number;
  courseParallel: string;
  title: string;
  date: string;
  description: string;
  description1440: string;
  description960: string;
  list: { text: string; text1440: string; text960: string }[];
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
};

export type CardType = {
  title: string;
  date: string;
  description: string;
  list: string[];
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
  color: string;
};

export const prices: Record<PriceType, Price> = {
  [PriceType.DEFAULT]: {
    price: 2190,
    basePrice: 5475,
    discount: '-60%',
    priceForLesson: 73,
  },
  [PriceType.COURSES]: {
    price: 2190,
    basePrice: 5475,
    discount: '-60%',
    priceForLesson: 438,
  },
  [PriceType.SUBJECTS]: {
    price: 6320,
    basePrice: 15800,
    discount: '-60%',
    priceForLesson: 73,
  },
};

export const DEFAULT_CARDS: CardType[] = [
  {
    title: 'Такие разные деньги',
    date: '9&nbsp;декабря 19:00',
    description: 'Узнаем, какие деньги были и&nbsp;есть в&nbsp;разных странах',
    list: [
      '&bull; изучим, как выглядели деньги в&nbsp;древности и&nbsp;как они изменились',
      '&bull; узнаем, как выглядят современные деньги в&nbsp;разных странах',
      '&bull; закрепим навыки безопасного поведения с&nbsp;деньгами',
    ],
    icon: CardCoinIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
  {
    title: 'Клавиатура и&nbsp;мышь',
    date: '13&nbsp;января 19:00',
    description: 'Научим уверенно пользоваться клавиатурой и&nbsp;мышью',
    list: [
      '&bull; узнаем разные функции кликов по&nbsp;мыши',
      '&bull; научимся выделять и&nbsp;перемещать объекты',
      '&bull; освоим разные клавиши на&nbsp;клавиатуре',
    ],
    icon: CardKeyboardIcon,
    bgColor: '#FFC2FC',
    color: '#8A8EE9',
  },
  {
    title: 'Герой произведения',
    date: '16&nbsp;января 19:00',
    description: 'Научим анализировать поступки и&nbsp;характер героев',
    list: [
      '&bull; оценим поступки героев',
      '&bull; опишем характеры героев через их&nbsp;слова и&nbsp;действия',
      '&bull; определим, к&nbsp;каким последствиям приводят поступки героев',
    ],
    icon: CardBookIcon,
    bgColor: '#FFF385',
    color: '#D48AE9',
  },
  {
    title: 'Безопасность на&nbsp;дороге',
    date: '20&nbsp;января 19:00',
    description: 'Научим безопасному поведению на&nbsp;дороге и&nbsp;рядом с&nbsp;ней',
    list: [
      '&bull; изучим, что значат цвета светофора и&nbsp;сигналы для пешеходов',
      '&bull; узнаем, как безопасно переходить дорогу и&nbsp;как вести себя рядом с&nbsp;ней',
      '&bull; закрепим навыки безопасного поведения',
    ],
    icon: CardCarIcon,
    bgColor: '#E9FF89',
    color: '#8A8EE9',
  },
  {
    title: 'Если кто-то обижает',
    date: '23&nbsp;января 19:00',
    description: 'Научим решать конфликты',
    list: [
      '&bull; разберемся, как отличить дружеские шутки от&nbsp;травли',
      '&bull; учимся правильно реагировать и&nbsp;выражать свои чувства в&nbsp;конфликте',
      '&bull; узнаем, к&nbsp;кому обратиться за&nbsp;помощью',
    ],
    icon: CardEvilIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
  {
    title: 'Где правда, а&nbsp;где&nbsp;&mdash; ложь?',
    date: '28&nbsp;января 19:00',
    description: 'Научим разбираться в&nbsp;ложной и&nbsp;правдивой информации',
    list: [
      '&bull; узнаем, что такое факт и&nbsp;заблуждение',
      '&bull; научимся проверять информацию в&nbsp;надежных источниках',
      '&bull; найдем правдивую и&nbsp;ложную информацию в&nbsp;тексте и&nbsp;докажем это',
    ],
    icon: CardTrueIcon,
    bgColor: '#D2EEFF',
    color: '#8A8EE9',
  },
  {
    title: 'Рисуем по&nbsp;шагам',
    date: '2&nbsp;февраля 19:00',
    description: 'Научим создавать животных из&nbsp;фигур',
    list: [
      '&bull; разделим образ животного на&nbsp;фигуры и&nbsp;повторим по&nbsp;шагам',
      '&bull; научимся соблюдать симметрию и&nbsp;пропорции частей тела',
      '&bull; нарисуем животное, соблюдая формы и&nbsp;экспериментируя с&nbsp;деталями',
    ],
    icon: CardPencilIcon,
    bgColor: '#FFC2FC',
    color: '#8A8EE9',
  },
  {
    title: 'Какие были динозавры?',
    date: '8&nbsp;февраля 19:00',
    description: 'Узнаем о&nbsp;разных видах динозавров',
    list: [
      '&bull; узнаем, что виды динозавров отличались из-за их&nbsp;образа жизни',
      '&bull; научимся определять травоядных и&nbsp;хищных динозавров',
      '&bull; узнаем, как защищались динозавры',
    ],
    icon: CardDinosaurIcon,
    bgColor: '#FFD3A1',
    color: '#9B7BEC',
  },
  {
    title: 'Где находится Солнце?',
    date: '13&nbsp;февраля 19:00',
    description: 'Узнаем о&nbsp;строении Солнечной системы',
    list: [
      '&bull; познакомимся с&nbsp;Солнцем и&nbsp;всеми планетами от&nbsp;Меркурия до&nbsp;Нептуна',
      '&bull; изучим, чем отличаются планеты друг от&nbsp;друга',
      '&bull; узнаем, какие еще небесные тела есть в&nbsp;Солнечной системе',
    ],
    icon: CardRocketIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
];

export const AB_CARDS_3_4_CLASS: CardType[] = [
  {
    title: 'Как копить деньги?',
    date: '9&nbsp;декабря 19:00',
    description: 'Научим откладывать сбережения и&nbsp;планировать покупки',
    list: [
      '&bull; узнаем, зачем и&nbsp;как копить деньги',
      '&bull; посчитаем, сколько времени нужно копить на&nbsp;желаемую покупку',
      '&bull; распланируем собственные накопления',
    ],
    icon: CardBankIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
  {
    title: 'Где правда, а&nbsp;где&nbsp;&mdash; ложь?',
    date: '13&nbsp;января 19:00',
    description: 'Научим разбираться в&nbsp;ложной и&nbsp;правдивой информации',
    list: [
      '&bull; узнаем, что такое факт и&nbsp;заблуждение',
      '&bull; научимся проверять информацию в&nbsp;надежных источниках',
      '&bull; найдем правдивую и&nbsp;ложную информацию в&nbsp;тексте и&nbsp;докажем это',
    ],
    icon: CardTrueIcon,
    bgColor: '#FFC2FC',
    color: '#8A8EE9',
  },
  {
    title: 'Что такое браузер?',
    date: '16&nbsp;января 19:00',
    description: 'Научим уверенно пользоваться браузером для учебных задач',
    list: [
      '&bull; научимся открывать сайты и&nbsp;вводить поисковые запросы',
      '&bull; создадим закладки и&nbsp;просмотрим историю браузера',
      '&bull; узнаем, почему не&nbsp;все сайты безопасны  ',
    ],
    icon: CardVideoIcon,
    bgColor: '#FFF385',
    color: '#D48AE9',
  },
  {
    title: 'Герой произведения',
    date: '20&nbsp;января 19:00',
    description: 'Научим анализировать поступки и&nbsp;характер героев',
    list: [
      '&bull; оценим поступки героев',
      '&bull; опишем характеры героев через их&nbsp;слова и&nbsp;действия',
      '&bull; определим, к&nbsp;каким последствиям приводят поступки героев',
    ],
    icon: CardBookIcon,
    bgColor: '#E9FF89',
    color: '#8A8EE9',
  },
  {
    title: 'Если кто-то обижает',
    date: '23&nbsp;января 19:00',
    description: 'Научим решать конфликты',
    list: [
      '&bull; разберемся, как отличить дружеские шутки от&nbsp;травли',
      '&bull; учимся правильно реагировать и&nbsp;выражать свои чувства в&nbsp;конфликте',
      '&bull; узнаем, к&nbsp;кому обратиться за&nbsp;помощью',
    ],
    icon: CardEvilIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
  {
    title: 'Задачи <br />на&nbsp;встречное движение',
    date: '28&nbsp;января 19:00',
    description: 'Научим решать текстовые задачи на&nbsp;движение навстречу друг другу',
    list: [
      '&bull; узнаем, как движущиеся навстречу объекты сокращают расстояние между собой',
      '&bull; научимся находить время и&nbsp;место встречи',
      '&bull; потренируемся решать задачи',
    ],
    icon: CardArrowsIcon,
    bgColor: '#D2EEFF',
    color: '#8A8EE9',
  },
  {
    title: 'Хочу стать программистом',
    date: '2&nbsp;февраля 19:00',
    description: 'Узнаем, что можно учить уже сейчас',
    list: [
      '&bull; узнаем, что такое алгоритм',
      '&bull; потренируем логику и&nbsp;научимся работать с&nbsp;простыми командами',
      '&bull; создадим первые мини-программы и&nbsp;анимации в&nbsp;Scratch',
    ],
    icon: CardComputerIcon,
    bgColor: '#FFC2FC',
    color: '#8A8EE9',
  },
  {
    title: 'Путешествие в&nbsp;прошлое',
    date: '8&nbsp;февраля 19:00',
    description:
      'Готовимся к&nbsp;5&nbsp;классу&nbsp;&mdash; узнаем, что и&nbsp;как изучает история',
    list: [
      '&bull; узнаем, кто такие историки и&nbsp;что они изучают',
      '&bull; узнаем, как восстанавливать прошлое благодаря вещам',
      '&bull; попробуем восстановить прошлое по&nbsp;историческим следам',
    ],
    icon: CardHistoryIcon,
    bgColor: '#FFD3A1',
    color: '#9B7BEC',
  },
  {
    title: 'Вселенная бесконечна?',
    date: '13&nbsp;февраля 19:00',
    description: 'Узнаем, что находится в&nbsp;Космосе и&nbsp;что такое Вселенная',
    list: [
      '&bull; разберемся, что включает в&nbsp;себя космос',
      '&bull; узнаем, чем Вселенная отличается от&nbsp;Солнечной системы',
      '&bull; создадим модель Вселенной и&nbsp;узнаем, бесконечная&nbsp;ли она',
    ],
    icon: CardPlanetIcon,
    bgColor: '#E5D2FF',
    color: '#8A8EE9',
  },
];

export const COURSES_CARDS: CourseCardType[] = [
  {
    id: 1,
    courseParallel: '1-2',
    title: 'Мои первые деньги',
    date: 'Старт 15 дек. 19:00',
    description: 'Объясним, что такое деньги и зачем они нужны',
    description1440: 'Объясним, что такое деньги и зачем они нужны',
    description960: 'Объясним, что такое деньги <br/> и зачем они нужны',
    list: [
      {
        text: '&bull; узнаем, как появились первые деньги <br/> и как они изменились со временем',
        text1440:
          '&bull; узнаем, как появились первые деньги <br/> и как они изменились со временем',
        text960: '&bull; узнаем, как появились первые деньги и как они изменились со временем',
      },
      {
        text: '&bull; разберемся, как обращаться с деньгами и зачем&nbsp;нужны банки и карты',
        text1440: '&bull; разберемся, как обращаться с деньгами <br/> и зачем нужны банки и карты',
        text960:
          '&bull; разберемся, как обращаться с деньгами <br/> и зачем нужны банки <br/> и карты',
      },
      {
        text: '&bull; научимся пользоваться онлайн-банком',
        text1440: '&bull; научимся пользоваться онлайн-банком',
        text960: '&bull; научимся пользоваться онлайн-банком',
      },
    ],
    icon: CourseCardMoneyIcon,
    bgColor: '#FFC2FC',
  },
  {
    id: 2,
    courseParallel: '1-2',
    title: 'Я осваиваю компьютер',
    date: 'Старт 22&nbsp;дек. 19:00',
    description: 'Научим пользоваться компьютером уверенно и&nbsp;безопасно',
    description1440: 'Научим пользоваться компьютером уверенно и безопасно',
    description960: 'Научим пользоваться компьютером уверенно <br/> и безопасно',
    list: [
      {
        text: '&bull; познакомимся с компонентами компьютера и их назначением',
        text1440: '&bull; познакомимся с компонентами компьютера и их назначением',
        text960: '&bull; познакомимся <br/> с компонентами компьютера и их назначением',
      },
      {
        text: '&bull; научимся вводить текст, работать <br/> с файлами и папками',
        text1440: '&bull; научимся вводить текст, работать <br/> с файлами и папками',
        text960: '&bull; научимся вводить текст, работать с файлами <br/> и папками',
      },
      {
        text: '&bull; освоим контекстное меню и&nbsp;правила безопасного обращения с&nbsp;техникой',
        text1440: '&bull; освоим контекстное меню и правила безопасного обращения с техникой',
        text960: '&bull; освоим контекстное меню и правила безопасного обращения с техникой',
      },
    ],
    icon: CourseCardComputerIcon,
    bgColor: '#FFF579',
  },
  {
    id: 3,
    courseParallel: '1-2',
    title: 'Моя книжная полка',
    date: 'Старт 16&nbsp;янв. 19:00',
    description: 'Научим понимать и обсуждать современные книги',
    description1440: 'Научим понимать и обсуждать современные книги',
    description960: 'Научим понимать <br/> и обсуждать современные книги',
    list: [
      {
        text: '&bull; проанализируем содержание произведений',
        text1440: '&bull; проанализируем содержание произведений',
        text960: '&bull; проанализируем содержание произведений',
      },
      {
        text: '&bull; научимся выделять тему и главную мысль',
        text1440: '&bull; научимся выделять тему и главную мысль',
        text960: '&bull; научимся выделять тему <br/> и главную мысль',
      },
      {
        text: '&bull; будем описывать героев и&nbsp;высказывать мнение о&nbsp;произведениях',
        text1440: '&bull; будем описывать героев и высказывать мнение о произведениях',
        text960: '&bull; будем описывать героев <br/> и высказывать мнение <br/> о произведениях',
      },
    ],
    icon: CourseCardBookIcon,
    bgColor: '#E1F787',
  },
  {
    id: 4,
    courseParallel: '1-2',
    title: 'Безопасность в&nbsp;жизни и сети',
    date: 'Старт 30&nbsp;янв. 19:00',
    description: 'Научим быть внимательными <br/> и осторожными дома, на улице и в сети',
    description1440: 'Научим быть внимательными <br/> и осторожными дома, на улице и в сети',
    description960: 'Научим быть внимательными <br/> и осторожными дома,<br/> на улице и в сети',
    list: [
      {
        text: '&bull; узнаем, какие опасные ситуации бывают и как их не допускать',
        text1440: '&bull; узнаем, какие опасные ситуации бывают <br/> и как их не допускать',
        text960: '&bull; узнаем, какие опасные ситуации бывают и как <br/> их не допускать',
      },
      {
        text: '&bull; потренируемся действовать правильно в игровых ситуациях',
        text1440: '&bull; потренируемся действовать правильно <br/> в игровых ситуациях',
        text960: '&bull; потренируемся действовать правильно <br/> в игровых ситуациях',
      },
      {
        text: '&bull; обсудим правила поведения и способы получения помощи',
        text1440: '&bull; обсудим правила поведения и способы получения помощи',
        text960: '&bull; обсудим правила поведения и способы <br/> получения помощи',
      },
    ],
    icon: CourseCardSafetyIcon,
    bgColor: '#E5D2FF',
  },
  {
    id: 5,
    courseParallel: '1-2',
    title: 'Как дружить?',
    date: 'Старт 3&nbsp;февр. 19:00',
    description: 'Научим строить дружеские отношения <br/> и разрешать споры',
    description1440: 'Научим строить дружеские отношения <br/> и разрешать споры',
    description960: 'Научим строить дружеские отношения и разрешать споры',
    list: [
      {
        text: '&bull; научимся выражать эмоции словесно <br/> и слушать собеседника',
        text1440: '&bull; научимся выражать эмоции словесно <br/> и слушать собеседника',
        text960: '&bull; научимся выражать эмоции словесно и слушать собеседника',
      },
      {
        text: '&bull; разберемся, как мириться, просить прощения и поддерживать друзей',
        text1440: '&bull; разберемся, как мириться, просить прощения и поддерживать друзей',
        text960: '&bull; разберемся, как мириться, просить прощения <br/> и поддерживать друзей',
      },
      {
        text: '&bull; узнаем, как реагировать на обиды <br/> и в каких случаях обращаться <br/> за помощью к взрослым',
        text1440:
          '&bull; узнаем, как реагировать на обиды <br/> и в каких случаях обращаться за помощью <br/> к взрослым',
        text960:
          '&bull; узнаем, как реагировать <br/> на обиды и в каких случаях обращаться за помощью <br/> к взрослым',
      },
    ],
    icon: CourseCardFriendsIcon,
    bgColor: '#FFC2FC',
  },
  {
    id: 6,
    courseParallel: '1-2',
    title: 'Мыслим критически',
    date: 'Старт 12&nbsp;февр. 19:00',
    description: 'Научим замечать, когда информации <br/> мало или она неверна',
    description1440: 'Научим замечать, когда информации мало или она неверна',
    description960: 'Научим замечать, когда информации мало или она неверна',
    list: [
      {
        text: '&bull; научимся задавать вопросы и проверять факты',
        text1440: '&bull; научимся задавать вопросы и проверять факты',
        text960: '&bull; научимся задавать вопросы и проверять факты',
      },
      {
        text: '&bull; разберемся, как отличать правду <br/> от заблуждений на простых примерах',
        text1440: '&bull; разберемся, как отличать правду <br/> от заблуждений на простых примерах',
        text960: '&bull; разберемся, как отличать правду от заблуждений <br/> на простых примерах',
      },
      {
        text: '&bull; узнаем, какие источники надежные <br/> и как ими пользоваться',
        text1440: '&bull; узнаем, какие источники надежные <br/> и как ими пользоваться',
        text960: '&bull; узнаем, какие источники надежные  и как ими пользоваться',
      },
    ],
    icon: CourseCardThinkIcon,
    bgColor: '#FFD3A1',
  },
  {
    id: 7,
    courseParallel: '3-4',
    title: 'Финансы и я',
    date: 'Старт 15 дек. 19:00',
    description: 'Научим бережно относиться к семейному бюджету и планировать расходы',
    description1440: 'Научим бережно относиться к семейному бюджету и планировать расходы',
    description960: 'Научим бережно относиться к семейному бюджету и планировать расходы',
    list: [
      {
        text: '&bull; узнаем, откуда приходят и на что тратятся деньги',
        text1440: '&bull; узнаем, откуда приходят и на что тратятся деньги',
        text960: '&bull; узнаем, откуда приходят <br/> и на что тратятся деньги',
      },
      {
        text: '&bull; научимся считать доходы, расходы <br/> и планировать бюджет',
        text1440: '&bull; научимся считать доходы, расходы <br/> и планировать бюджет',
        text960: '&bull; научимся считать доходы, расходы и планировать бюджет',
      },
      {
        text: '&bull; сможем анализировать бюджет <br/> и предлагать, как его улучшить',
        text1440: '&bull; сможем анализировать бюджет <br/> и предлагать, как его улучшить',
        text960: '&bull; сможем анализировать бюджет и предлагать, как его улучшить',
      },
    ],
    icon: CourseCardMoneyIcon2,
    bgColor: '#FFC2FC',
  },
  {
    id: 8,
    courseParallel: '3-4',
    title: 'Я осваиваю интернет',
    date: 'Старт 22&nbsp;дек. 19:00',
    description: 'Научим безопасно и осознанно пользоваться интернетом',
    description1440: 'Научим безопасно и осознанно пользоваться интернетом',
    description960: 'Научим безопасно и осознанно пользоваться интернетом',
    list: [
      {
        text: '&bull; узнаем, как пользоваться браузером, искать информацию и общаться в сети',
        text1440: '&bull; узнаем, как пользоваться браузером, искать информацию и общаться в сети',
        text960:
          '&bull; узнаем, как пользоваться браузером, искать информацию и общаться <br/> в сети',
      },
      {
        text: '&bull; научимся защищать свои персональные данные и создавать надежные пароли',
        text1440: '&bull; научимся защищать свои персональные данные и создавать надежные пароли',
        text960: '&bull; научимся защищать свои персональные данные и создавать надежные пароли',
      },
      {
        text: '&bull; разберемся, как определять признаки мошенничества',
        text1440: '&bull; разберемся, как определять признаки мошенничества',
        text960: '&bull; разберемся, как определять признаки мошенничества',
      },
    ],
    icon: CourseCardComputerIcon2,
    bgColor: '#FFF579',
  },
  {
    id: 9,
    courseParallel: '3-4',
    title: 'Моя книжная полка',
    date: 'Старт 16&nbsp;янв. 19:00',
    description: 'Научим анализировать прочитанное и расширим круг чтения',
    description1440: 'Научим анализировать прочитанное и расширим круг чтения',
    description960: 'Научим анализировать прочитанное и расширим круг чтения',
    list: [
      {
        text: '&bull; увидим, как события, пейзажи и детали помогают понять произведение',
        text1440: '&bull; увидим, как события, пейзажи и детали помогают понять произведение',
        text960: '&bull; увидим, как события, пейзажи и детали помогают понять произведение',
      },
      {
        text: '&bull; проанализируем поведение героев, <br/> их характеры',
        text1440: '&bull; проанализируем поведение героев, <br/> их характеры',
        text960: '&bull; проанализируем поведение героев, <br/> их характеры',
      },
      {
        text: '&bull; научимся формировать собственное мнение о произведении и его письменно выражать',
        text1440:
          '&bull; научимся формировать собственное мнение о произведении и его письменно выражать',
        text960:
          '&bull; научимся формировать собственное мнение <br/> о произведении и его письменно выражать',
      },
    ],
    icon: CourseCardBookIcon2,
    bgColor: '#E1F787',
  },
  {
    id: 10,
    courseParallel: '3-4',
    title: 'Текстовые задачи на движение',
    date: 'Старт 30&nbsp;янв. 19:00',
    description: 'Научим понимать и решать задачи на движение',
    description1440: 'Научим понимать и решать задачи на движение',
    description960: 'Научим понимать и решать задачи на движение',
    list: [
      {
        text: '&bull; поймем связь между расстоянием, временем и скоростью',
        text1440: '&bull; поймем связь между расстоянием, временем и скоростью',
        text960: '&bull; поймем связь между расстоянием, временем <br/> и скоростью',
      },
      {
        text: '&bull; научимся определять тип движения <br/> и выбирать способ решения задачи',
        text1440: '&bull; научимся определять тип движения <br/> и выбирать способ решения задачи',
        text960: '&bull; научимся определять тип движения и выбирать способ решения задачи',
      },
      {
        text: '&bull; научимся переводить скорость между км/ч и м/с и находить среднюю скорость',
        text1440:
          '&bull; научимся переводить скорость между <br/> км/ч и м/с и находить среднюю скорость',
        text960:
          '&bull; научимся переводить скорость между км/ч и м/с <br/> и находить среднюю скорость',
      },
    ],
    icon: CourseCardMooveIcon,
    bgColor: '#E5D2FF',
  },
  {
    id: 11,
    courseParallel: '3-4',
    title: 'Как дружить?',
    date: 'Старт 3&nbsp;февр. 19:00',
    description: 'Научим решать конфликты и разовьем навыки общения',
    description1440: 'Научим решать конфликты и разовьем навыки общения',
    description960: 'Научим решать конфликты и разовьем навыки общения',
    list: [
      {
        text: '&bull; научимся строить дружеские отношения и проявлять уважение <br/> к другим',
        text1440: '&bull; научимся строить дружеские отношения <br/> и проявлять уважение к другим',
        text960:
          '&bull; научимся строить дружеские отношения <br/> и проявлять уважение <br/> к другим',
      },
      {
        text: '&bull; научимся находить признаки травли <br/> и безопасно реагировать',
        text1440: '&bull; научимся находить признаки травли <br/> и безопасно реагировать',
        text960: '&bull; научимся находить признаки травли <br/> и безопасно реагировать',
      },
      {
        text: '&bull; узнаем, как выражать свои чувства <br/> и поддерживать друзей',
        text1440: '&bull; узнаем, как выражать свои чувства <br/> и поддерживать друзей',
        text960: '&bull; узнаем, как выражать свои чувства и поддерживать друзей',
      },
    ],
    icon: CourseCardFriendsIcon2,
    bgColor: '#FFC2FC',
  },
  {
    id: 12,
    courseParallel: '3-4',
    title: 'Мыслим критически',
    date: 'Старт 12&nbsp;февр. 19:00',
    description: 'Научим анализировать и проверять информацию, делать выводы',
    description1440: 'Научим анализировать и проверять информацию, делать выводы',
    description960: 'Научим анализировать и проверять информацию, делать выводы',
    list: [
      {
        text: '&bull; научимся читать и представлять данные в таблицах, графиках и текстах',
        text1440: '&bull; научимся читать и представлять данные в таблицах, графиках и текстах',
        text960:
          '&bull; научимся читать <br/> и представлять данные <br/> в таблицах, графиках и текстах',
      },
      {
        text: '&bull; научимся замечать недостающую информацию и задавать уточняющие вопросы',
        text1440: '&bull; научимся замечать недостающую информацию и задавать уточняющие вопросы',
        text960: '&bull; научимся замечать недостающую информацию и задавать уточняющие вопросы',
      },
      {
        text: '&bull; узнаем, что такое надежный источник <br/> и как проверять факты',
        text1440: '&bull; узнаем, что такое надежный источник и как проверять факты',
        text960: '&bull; узнаем, что такое надежный источник и как проверять факты',
      },
    ],
    icon: CourseCardThinkIcon2,
    bgColor: '#FFD3A1',
  },
];

export const SUBJECTS_CARDS: SubjecCardType[] = [
  {
    id: 1,
    title: 'Математика',
    date: 'Старт в декабре',
    list: [
      '&bull; от 2 занятий в неделю',
      '&bull; 1-4 класс',
      '&bull; занятия для каждого класса проходят отдельно',
    ],
    icon: SubjectMathIcon,
    bgColor: '#FFC2FC',
  },
  {
    id: 2,
    title: 'Русский\nязык',
    date: 'Старт в декабре',
    list: [
      '&bull; от 2 занятий в неделю',
      '&bull; 1-4 класс',
      '&bull; занятия для каждого класса проходят отдельно',
    ],
    icon: SubjectRussianIcon,
    bgColor: '#FFD3A1',
  },
  {
    id: 3,
    title: 'Английский\nязык',
    date: 'Старт в декабре',
    list: [
      '&bull; от 2 занятий в неделю',
      '&bull; 1-4 класс',
      '&bull; занятия для каждого класса проходят отдельно',
    ],
    icon: SubjectEnglishIcon,
    bgColor: '#E5D2FF',
  },
  {
    id: 4,
    title: 'Окружающий\nмир',
    date: 'Старт в декабре',
    list: [
      '&bull; от 2 занятий в неделю',
      '&bull; 1-4 класс',
      '&bull; занятия для каждого класса проходят отдельно',
    ],
    icon: SubjectEnvironmentIcon,
    bgColor: '#E1F787',
  },
];
